export default "__VITE_ASSET__CtxFhMkm__"